import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Form, FormItem, Input, Radio, SubmitButton } from 'formik-antd';
import { Formik, ErrorMessage } from 'formik';
import { message, Typography, List, Switch, Avatar, Skeleton } from 'antd';
import * as Yup from 'yup';
import { Mutation } from '@apollo/client/react/components';
import slugify from 'slugify';
import { GET_TOURNAMENT_QUERY } from '../data/queries';
import { UPDATE_TOURNAMENT_MUTATION } from '../data/mutations';

const { TextArea } = Input;
const { Text } = Typography;

function TBNotificationSettingsForm(props) {
    const { tournament, history } = props;
    const [loading, setLoading] = useState(false);

    function onChange(checked, name, updateTournament) {
        let input = {};
        if (name === 'use_in_app_messaging') {
            input.use_in_app_messaging = checked;
        } else if (name === 'use_text_messaging') {
            input.use_text_messaging = checked;
        }
        setLoading(true);
        updateTournament({
            variables: {
                id: tournament.id,
                changes: input,
            },
            refetchQueries: () => [
                {
                    query: GET_TOURNAMENT_QUERY,
                    variables: { id: tournament.id },
                    notifyOnNetworkStatusChange: true,
                    awaitRefetchQueries: true,
                },
            ],
        });
    }

    const notifications = [
        {
            title: 'In-App Match notifications',
            description: 'Notify players when they are scheduled to play a match via the DigitalPool app.',
            name: 'use_in_app_messaging',
            checked: tournament.use_in_app_messaging || false,
        },
        {
            title: 'SMS Match notifications',
            description: 'Notify players when they are scheduled to play a match via SMS.',
            name: 'use_text_messaging',
            checked: tournament.use_text_messaging || false,
        },
    ];

    return (
        <Mutation
            mutation={UPDATE_TOURNAMENT_MUTATION}
            onCompleted={(res) => {
                console.log(res);
                const tournament = res.update_tournaments.returning[0];
                setLoading(false);
                message.success('Changes saved');
                // const result = league.insert_leagues.returning[0];
                // props.history.push(`/league-manager/${result.slug}/dashboard`);
                // const { updateLeague } = data;
                // history.push(`/league-manager/${league.slug}/settings/notifications`);
            }}
            awaitRefetchQueries
        >
            {(updateTournament, { error }) => {
                if (error) {
                    alert('Something went wrong');
                }
                return (
                    <List
                        // loading={initLoading}
                        itemLayout="horizontal"
                        // loadMore={loadMore}
                        dataSource={notifications}
                        renderItem={(item) => (
                            <List.Item
                                actions={[
                                    <Switch
                                        checkedChildren="ON"
                                        unCheckedChildren="OFF"
                                        defaultChecked={item.checked}
                                        onChange={(checked) => onChange(checked, item.name, updateTournament)}
                                    />,
                                ]}
                            >
                                <Skeleton avatar title={false} loading={item.loading} active>
                                    <List.Item.Meta title={item.title} description={item.description} />
                                </Skeleton>
                            </List.Item>
                        )}
                    />
                );
            }}
        </Mutation>
    );
}

export default withRouter(TBNotificationSettingsForm);
